



























































import { getUserData } from "@/auth/getUserData";
import useArchiveChat from "@/composables/v3/useArchiveChat";
import useAssignChat from "@/composables/v3/useAssignChat";
import useContact from "@/composables/v3/useContact";
import useDeleteChat from "@/composables/v3/useDeleteChat";
import useReadChat from "@/composables/v3/useReadChat";
import useChatsListContextMenu from "@/views/modules/messaging-inbox/useChatsListContextMenu";
import { defineComponent } from "@vue/composition-api";
import contextMenu from "vue-context-menu";

export default defineComponent({
    components: {
        contextMenu,
    },
    setup(_, { root }) {
        const { ctxMenu, ctxChat, ctxAllowDelete } = useChatsListContextMenu();

        const { assignToMe } = useAssignChat();
        const { archive, unarchive } = useArchiveChat();
        const { read, unread } = useReadChat();
        const { deleteChat } = useDeleteChat(root);
        const { toggleVip, toggleBlock } = useContact();
        return {
            archive,
            assignToMe,
            ctxAllowDelete,
            ctxChat,
            ctxMenu,
            deleteChat,
            getUserData,
            read,
            toggleBlock,
            toggleVip,
            unarchive,
            unread,
        };
    },
});
